import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { ClientRelationService } from 'app/layout/common/client-relation/service/client-relation.service';
import { forkJoin } from 'rxjs';

/** Panel administratora: nawigacja i relacje klienta (bez demonstracyjnych danych szablonu Fuse). */
export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const clientRelationService = inject(ClientRelationService);

    return forkJoin([navigationService.get(), clientRelationService.loadRelations()]);
};
